import { getInterviewSectionTitle } from "@repo/app-types/entities/interviewSection/definition";
import type { FC, ReactNode } from "react";
import { TreeItem } from "react-aria-components";
import { treeItem } from "../../components/tree/treeStyles.js";
import type { VisibleInterviewSectionDefinition } from "../interviewSections/definitions/state.js";
import { serializeTreeItemKey } from "../projects/projectSettings/training/courseTreeHelpers.js";

export interface LessonTreeItemProps {
  sectionId: string;
  section: VisibleInterviewSectionDefinition | undefined;
  isDisabled?: boolean;
  onAction?: () => void;
  className?: string;
  isLastItemAtLevel?: boolean;
  children?: ReactNode;
}

/** Renders a lesson tree item in the course tree UI. */
export const LessonTreeItem: FC<LessonTreeItemProps> = ({
  sectionId,
  section,
  isDisabled,
  onAction,
  className,
  isLastItemAtLevel,
  children,
}) => {
  const treeItemId = serializeTreeItemKey({
    type: "lesson",
    sectionId,
  });

  const textValue = getInterviewSectionTitle(
    section?.settings,
    "Unknown lesson",
  );

  return (
    <TreeItem
      id={treeItemId}
      textValue={textValue}
      isDisabled={isDisabled}
      onAction={onAction}
      className={treeItem({
        className,
        isLastItemAtLevel,
      })}
    >
      {children}
    </TreeItem>
  );
};
